import { Controller } from "@hotwired/stimulus"

// The donation fund form's Card metric (TMS-1803): shows the period for a
// calculated metric and the number and label for a manual one. Each group lists
// the metric kinds it belongs to in data-kinds; hidden groups' fields are
// disabled so they are not submitted.
export default class extends Controller {
  static targets = ["kind", "group"]

  connect() {
    this.sync()
  }

  sync() {
    const kind = this.kindTargets.find((input) => input.checked)?.value
    this.groupTargets.forEach((group) => {
      const shown = group.dataset.kinds.split(" ").includes(kind)
      group.hidden = !shown
      group.querySelectorAll("input").forEach((input) => { input.disabled = !shown })
    })
  }
}
